export default __webpack_public_path__ + "69cff5f1243cfc4251535e258f50d131.svg";